import inject from "scripts/ioc/inject";
import BaseContentDetailsPageView from "scripts/views/baseContentDetailsPageView";
import ContentDetailsBookPageNavView from "scripts/views/contentDetailsBookPageNavView";

import templateContentDetailsBookPage from "templates/contentDetailsBookPage.hbs";

class ContentDetailsBookPageView extends BaseContentDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
    bookshelfService = inject("bookshelfService"),
  ) {
    super(
      options,
      breadcrumbService,
      connectionService,
      securityService,
      bookshelfService,
    );

    this.initializeBookshelfDeps();
  }

  get template() {
    return templateContentDetailsBookPage;
  }

  render() {
    super.render();
    this.renderBookshelfElements();

    return this;
  }

  createNavView() {
    const organizationProperties = this.securityService.getUser().getActiveOrganizationProperty(
        "organizationProperties",
    );

    return new ContentDetailsBookPageNavView({
      model: this.model,
      mediaModel: this.mediaModel,
      organizationProperties,
    });
  }
}

export default ContentDetailsBookPageView;
